module.exports = __webpack_public_path__ + "media/images/pic/hero/woman-ff86f8fd6a357f58921b19c27ddcdfae.webp";